import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/lo/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin" });
  },
});
